import React, { useState } from "react";
import { OverlayTrigger, Popover, Form, Col, Row } from "react-bootstrap";
import { DayPicker } from "react-day-picker";

function DateRangePicker({
  handleDayClick,
  startDate,
  endDate,
  range,
  datePopoverOpen,
  setDatePopoverOpen,
  filterText,
  disableAfter,
  visibleMonths,
  setVisibleMonths,
}) {
  const popover = (
    <Popover className="dashboard-day-range-picker-months">
      <Popover.Body>
        <DayPicker
          key={range.from && range.to && `${range.from}-${range.to}`}
          numberOfMonths={2}
          mode="range"
          selected={range}
          onDayClick={handleDayClick}
          modifiersStyles={{ backgroundColor: "white", width: "100%" }}
          month={visibleMonths}
          onMonthChange={(month) => setVisibleMonths(month)}
          disabled={disableAfter && { after: new Date() }}
        />
      </Popover.Body>
    </Popover>
  );

  return (
    <Form.Group
      as={Col}
      controlId="formGridMonth"
      className="custom-date-range-dates"
    >
      {filterText && <Form.Label>{filterText}</Form.Label>}
      <OverlayTrigger
        trigger="click"
        placement="bottom"
        show={datePopoverOpen}
        onToggle={setDatePopoverOpen}
        overlay={popover}
        rootClose
      >
        <Row className="align-items-center">
          <Col>
            <Form.Control
              className="dashboard-day-range-picker"
              type="text"
              placeholder="Start Date"
              value={startDate}
              readOnly
            />
          </Col>
          →
          <Col>
            <Form.Control
              className="dashboard-day-range-picker"
              type="text"
              placeholder="End Date"
              value={endDate}
              readOnly
            />
          </Col>
        </Row>
      </OverlayTrigger>
    </Form.Group>
  );
}

export default DateRangePicker;
